import App from './App.vue'
// import HelloWorld from './components/HelloWorld.vue'
import Vue from 'vue'

// import wrap from '@vue/web-component-wrapper'

Vue.config.productionTip = false

// const CustomElement = wrap(Vue, HelloWorld)
// window.customElements.define('hello-world', CustomElement)

new Vue({
  render: h => h(App)
}).$mount('#app')

/*
function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
*/
